export const HowareuLogo = () => {
  return (
    <svg
      style={{ height: "28px", width: "90px" }}
      width="130"
      height="40"
      viewBox="0 0 152 40"
      fill="none"
    >
      <path
        d="M0 10.9185H11.0815V38.7352H15.1259V10.9185H26.2074V7.50369H0V10.9185Z"
        fill="#333333"
      />
      <path
        d="M32.2353 32.6277V7.50366H28.2538V38.7351H32.0593L49.6242 13.6092V38.7351H53.6705V7.50366H49.8019L32.2353 32.6277Z"
        fill="#333333"
      />
      <path
        d="M69.5741 16.4055C69.5741 20.1074 71.8278 22.9 75.7241 24.0129C72.726 25.187 72.2445 28.2129 71.6982 31.5555C71.1667 35.1129 70.9871 35.5629 70.0908 35.5629C68.8741 35.5629 67.7908 35.3351 67.7908 35.3351V38.837C67.7908 38.837 69.1982 39.1629 70.4075 39.1629C74.2501 39.1629 74.8593 36.4333 75.6075 31.6037C76.1612 27.7759 77.1315 25.7481 80.9019 25.7481H89.6278V38.7351H93.6741V7.50366H80.6482C73.6464 7.50366 69.5704 10.8018 69.5704 16.4055H69.5741ZM89.6334 10.8574V22.3907H80.526C74.9427 22.3907 73.7704 19.2759 73.7704 16.6129C73.7704 12.887 76.3278 10.8574 80.9704 10.8574H89.6334Z"
        fill="#333333"
      />
      <path
        d="M123.015 7.50366H118.335L107.713 21.3796H102.306V7.50366H98.3223V38.7351H102.306V24.7963H107.713L118.398 38.7351H123.078L111.157 23.0888L123.015 7.50366Z"
        fill="#333333"
      />
      <path
        d="M141.481 32.9241H136.783V38.7334H141.481V32.9241Z"
        fill="#333333"
      />
      <path
        d="M140.8 31.0482H137.467C137.467 24.0611 136.805 19.6722 136.368 16.7667C135.948 13.9704 135.737 12.5667 136.687 11.463C137.483 10.537 138.657 10.537 139.043 10.537C141.5 10.537 143.148 13.6148 144.741 16.5907C145.005 17.0852 145.328 17.687 145.6 18.1519C146.294 17.1333 147.118 14.4056 147.118 11.863C147.118 4.81482 142.774 3.33519 139.13 3.33519C135.676 3.33519 132.783 4.72779 131.193 7.15557C129.483 9.76668 129.461 13.3093 131.13 17.1333L128.074 18.4667C125.941 13.5778 126.059 8.91297 128.404 5.32964C130.62 1.94445 134.53 0.00186157 139.128 0.00186157C146.217 0.00186157 150.45 4.43705 150.45 11.863C150.45 15.1296 149.172 21.8778 145.226 21.8778C143.789 21.8778 143.083 20.5593 141.8 18.1648C141.276 17.1852 140.176 15.1333 139.381 14.2463C139.441 14.8074 139.552 15.5463 139.661 16.2722C140.085 19.0926 140.796 23.813 140.796 31.0482H140.8Z"
        fill="#333333"
      />
    </svg>
  );
};
